import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ClipboardService } from 'ngx-clipboard';
import { CacheService } from '../services/cache.service';
import { ConstantsService } from "../services/constants.service";
import { environment } from 'src/environments/environment';
import { SharedMixpanelService } from '../services/shared-mixpanel.service';
@Component({
  selector: 'app-sharepopup',
  templateUrl: './sharepopup.component.html',
  styleUrls: ['./sharepopup.component.scss']
})
export class SharepopupComponent implements OnInit {
  closeResult: string;
  public url;
  public textCopied = false;
  public videoData;
  public author;
  public location;


  constructor(private modalService: NgbModal, private cache: CacheService,
    public constants: ConstantsService,
    private clipboardService: ClipboardService,
    private mixpanel: SharedMixpanelService) { }


  ngOnInit(): void {
  }
  openVerticallyCentered(content) {
    this.videoData = this.cache.get();
    this.author = this.videoData?.author;
    this.location = this.videoData?.cityLocation;
    this.url = `${environment.DOMAIN}share.html?id=${this.videoData?.url1}`;
    this.textCopied = false;
    this.modalService.open(content, { centered: true, windowClass: "myCustomModalClass" });
    this.mixpanel.actions.track("Sharing Window", {
      "Video Details": this.videoData
    })
  }
  copyText(event) {
    this.textCopied = this.clipboardService.copyFromContent(this.url);
    if (this.textCopied) {
      this.clipboardService.destroy();
    }
  }


}
